<div class="min-vh-100 bg-light">
  <app-header [page]="'Admin'"></app-header>
  <main class="container py-4">
    <app-admin-machine-learning-nav></app-admin-machine-learning-nav>

    <div class="d-flex flex-column flex-lg-row justify-content-between gap-3 mb-4">
      <div>
        <div class="d-flex align-items-center gap-2 mb-1">
          <h4 class="fw-bold mb-0">Matching Intelligence</h4>
          <button type="button" class="ml-page-help-link" (click)="pageGuide.scrollToGuide()" title="How to use this page" aria-label="Go to the How to use this page guide">?</button>
        </div>
        <div class="text-muted small">Compare deterministic order selection with the explainable shadow ranking layer.</div>
      </div>
      <div class="d-flex flex-wrap gap-2 align-items-end">
        <div><label class="form-label small mb-1">From</label><input class="form-control form-control-sm" type="date" [(ngModel)]="fromDate"></div>
        <div><label class="form-label small mb-1">To</label><input class="form-control form-control-sm" type="date" [(ngModel)]="toDate"></div>
        <button class="btn btn-primary btn-sm" (click)="load()" [disabled]="loading">Refresh</button>
      </div>
    </div>
    <div *ngIf="error" class="alert alert-danger">{{ error }}</div>
    <div *ngIf="loading && !summary" class="text-center py-5"><div class="spinner-border text-primary"></div></div>

    <ng-container *ngIf="summary as data">
      <section class="hero p-4 mb-4">
        <div class="row g-3 align-items-center">
          <div class="col-lg-8">
            <h5 class="fw-bold mb-1">Deterministic selection remains authoritative</h5>
            <p class="text-muted mb-0">The ML layer only compares eligible candidates after the existing matching rules have selected and committed a match.</p>
          </div>
          <div class="col-lg-4 text-lg-end">
            <div class="small text-muted">Agreement rate</div>
            <div class="display-6 fw-bold" [ngClass]="agreementClass(data.agreementRatePercent)">{{ data.agreementRatePercent | number:'1.0-1' }}%</div>
          </div>
        </div>
      </section>

      <div class="row g-3 mb-4">
        <div class="col-6 col-xl-3"><div class="stat"><div class="label">Selections observed</div><div class="value">{{ data.selectionObservations }}</div></div></div>
        <div class="col-6 col-xl-3"><div class="stat"><div class="label">Candidates scored</div><div class="value">{{ data.candidatePredictions }}</div></div></div>
        <div class="col-6 col-xl-3"><div class="stat"><div class="label">Shadow alternatives</div><div class="value">{{ data.shadowAlternatives }}</div></div></div>
        <div class="col-6 col-xl-3"><div class="stat" [class.danger]="data.highOrCriticalDeterministicSelections > 0"><div class="label">High-risk selections</div><div class="value">{{ data.highOrCriticalDeterministicSelections }}</div></div></div>
      </div>

      <div class="row g-4">
        <div class="col-lg-6">
          <section class="panel p-4 h-100">
            <h5 class="fw-bold mb-3">Selection comparison</h5>
            <div class="metric-row"><span>Deterministic agreements</span><strong>{{ data.deterministicAgreements }}</strong></div>
            <div class="metric-row"><span>Shadow alternatives</span><strong>{{ data.shadowAlternatives }}</strong></div>
            <div class="metric-row"><span>Average selected-candidate risk</span><strong>{{ data.averageDeterministicCandidateRiskScore | number:'1.0-2' }}</strong></div>
            <div class="metric-row"><span>Latest observation</span><strong>{{ data.latestObservationAt ? (data.latestObservationAt | date:'medium') : 'No observations' }}</strong></div>
          </section>
        </div>
        <div class="col-lg-6">
          <section class="panel p-4 h-100">
            <h5 class="fw-bold mb-3">Audit views</h5>
            <p class="text-muted small">Inspect candidate-level explanations and completed selection comparisons in prediction history.</p>
            <div class="d-grid gap-2">
              <a class="btn btn-outline-primary" [routerLink]="['/admin/machine-learning/predictions']" [queryParams]="{ predictionType: 'MatchCandidateRisk' }">Candidate risk predictions</a>
              <a class="btn btn-outline-primary" [routerLink]="['/admin/machine-learning/predictions']" [queryParams]="{ predictionType: 'MatchCandidateSelection' }">Selection comparison predictions</a>
            </div>
          </section>
        </div>
      </div>
    </ng-container>

        <app-admin-ml-page-guide #pageGuide id="ml-page-guide" tabindex="-1"
      [purpose]="'Compare deterministic order matching with the shadow candidate-risk ranking.'"
      [steps]="['Select a meaningful date window and review agreement rate, shadow alternatives, and high-risk deterministic selections.', 'Investigate disagreements by opening MatchCandidateRisk and MatchCandidateSelection records in Prediction History.', 'Use the findings to tune future ranking logic, but validate settlement outcomes before changing any deterministic matching rule.']"
      [important]="'This page is observational. Existing currency, rate, ownership, and order-status rules remain authoritative.'"
      [accessNote]="'Read-only for Admin and SuperAdmin.'">
    </app-admin-ml-page-guide>

    <app-footer></app-footer>
  </main>
</div>
